import type { OrgConfig, ScenarioDoc } from '../engine/types';

/**
 * §5.3.1 — in practice the rep may select a persona or take a random one. In
 * summative it is assigned from the seed and never offered, which is why this
 * screen exists only on the practice path.
 */
export function PersonaPicker({
  scenario, config, onStart, onCancel,
}: {
  scenario: ScenarioDoc;
  config: OrgConfig;
  onStart: (choice: string | 'random') => void;
  onCancel: () => void;
}) {
  const eligible = config.personas.filter((p) => scenario.eligiblePersonas.includes(p.id));

  return (
    <main className="shell">
      <header className="drill-head">
        <button className="ghost small" onClick={onCancel}>Back</button>
      </header>

      <div>
        <h1>{scenario.title}</h1>
        <p className="muted">
          Pick who you want to practice against, or take whoever comes up. In a
          certification attempt you do not get to choose.
        </p>
      </div>

      <ul className="persona-list">
        {eligible.map((p) => (
          <li key={p.id}>
            <button className="persona-card" onClick={() => onStart(p.id)}>
              <span className="persona-name">
                {p.name}
                {p.vulnerable && <span className="pill pill-vulnerable">handle with care</span>}
              </span>
              {p.soundsLike && <span className="persona-sounds">“{p.soundsLike}”</span>}
              <span className="persona-job small muted">{p.primaryJob}</span>
            </button>
          </li>
        ))}
      </ul>

      <button className="primary wide" onClick={() => onStart('random')}>
        Give me whoever answers
      </button>
    </main>
  );
}
